
(function () {
  'use strict';

  const SALE_COLLECTION_URL =
    (window.Shopify?.routes?.root || '/') + 'collections/on-sale';

  function isSaleSearch(value) {
    const keyword = String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');

    return (
      keyword === 'sale' ||
      keyword === 'on sale' ||
      keyword === 'on-sale'
    );
  }

  function redirectToSale() {
    window.location.assign(SALE_COLLECTION_URL);
  }

  // Handle all search form submissions
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;

      const input = form.querySelector('input[name="q"]');

      if (!input || !isSaleSearch(input.value)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      redirectToSale();
    },
    true
  );

  // Handle search buttons and View All Results clicks
  document.addEventListener(
    'click',
    function (event) {
      if (!(event.target instanceof Element)) return;

      const button = event.target.closest(
        '.search-flydown__continue'
      );

      if (!button) return;

      const wrapper = button.closest('[data-live-search]');
      const input =
        wrapper?.querySelector('[data-live-search-input]') ||
        wrapper?.querySelector('input[name="q"]');

      if (!input || !isSaleSearch(input.value)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      redirectToSale();
    },
    true
  );

  // Handle Enter key in search inputs
  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter') return;

      const input = event.target;

      if (!(input instanceof HTMLInputElement)) return;

      if (
        input.name !== 'q' &&
        !input.matches('[data-live-search-input]')
      ) {
        return;
      }

      if (!isSaleSearch(input.value)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      redirectToSale();
    },
    true
  );
})();
